// @ts-check

// /**
//  * @typedef {{
//  *  companyLogo: string,
//  *  companyLogoAltText: string,
//  * companySummary: string,
//  * statistics: []<string>
//  * }} PartnerCompanyInfo
//  */

// /**
//  * @type {Map<string,PartnerCompanyInfo>}
//  */

export const partnerCompanyInfo = [
  {
    companyLogo: '/omada.png',
    companyLogoAltText: 'Omada Company Logo',
    companySummary: 'Omada provides a personalized program for managing diabetes, hypertension, weight loss, as well as joint and muscle pain. Members receive dedicated coaches, smart devices, interactive lessons, and more to help create long-term results through behavior change.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">79%</span> of Prevention Program participants </span>felt increased satisfaction towards their employer',
      '<span className="text-blue font-bold"><span className="text-3xl block">99%</span> of MSK Program participants </span>are satisfied with the care of the program',
      '<span className="text-blue font-bold"><span className="text-3xl block">76%</span> of Diabetes &#38; Hypertension Program participants </span>meet A1C reduction goals in the program',
    ]
  },
  {
    companyLogo: '/meru-health.png',
    companyLogoAltText: 'Meru Health Logo',
    companySummary: 'Meru combines therapist and psychiatrist support, chat-based coaching, virtual workshops, evidence-based digital content, biofeedback wearables, anonymous peer support, meditation practices, and more into a clinically proven 12-week treatment program that will transform your employees&#39; mental health.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">75%</span> of participants</span> reach depression or anxiety remission after program',
      '<span className="text-blue font-bold"><span className="text-3xl block">85%</span> of participants</span> show clinically significant improvement',
      '<span className="text-blue font-bold"><span className="text-3xl block">89%</span> completion rate</span> with significant symptom reduction',
    ]
  },
  {
    companyLogo: '/maven.png',
    companyLogoAltText: 'Maven Logo',
    companySummary: 'As part of the Women’s Health care plan, Maven provides support for fertility, pregnancy, postpartum and parenthood. This is a family benefits solution with comprehensive, patient-first support on a modern platform.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">20%</span> lower</span> c-section rates',
      '<span className="text-blue font-bold"><span className="text-3xl block">32%</span> lower</span> NICU admission rates',
      '<span className="text-blue font-bold"><span className="text-3xl block">90%</span> of visits</span> are with specialists rather than OB/GYNs',
    ]
  },
  {
    companyLogo: '/quit-genius.png',
    companyLogoAltText: 'Quit Genius Logo',
    companySummary: 'Digital clinic that delivers comprehensive medication-assisted treatment programs for addiction, tobacco, alcohol, and opioids. QuitGenius combines cognitive behavioral therapy and medications to drive holistic and sustained behavior changes.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">88%</span> member</span> activation rate',
      '<span className="text-blue font-bold"><span className="text-3xl block">52%</span>tobacco</span> quit rate',
      '<span className="text-blue font-bold"><span className="text-3xl block">73%</span> of participants</span> reach alcohol abstinence or drinking below safe limit',
    ]
  },
  {
    companyLogo: '/dr-on-demand.png',
    companyLogoAltText: 'Dr On Demand Logo',
    companySummary: 'With 24/7 access to top doctors, psychiatrists, psychologists, therapists, and other medical experts, members can receive world-class care anywhere within moments. Everyday & Urgent Care services are available within minutes and Behavioral Health services within only a couple days for the first appointment. These providers can write prescriptions, order lab work, help members find specialized follow-up care from an in-network doctor if necessary, and much more to help ensure Evry members have their physical and mental health needs met.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">95%</span> successful</span> case resolution rate',
      '<span className="text-blue font-bold"><span className="text-3xl block">63%</span> reduction</span> in ER visits',
      '<span className="text-blue font-bold"><span className="text-3xl block">4.5/5</span> member</span> rating',
    ]
  },
  {
    companyLogo: '/propeller.png',
    companyLogoAltText: 'Propeller Logo',
    companySummary: 'Propeller and their parent company, ResMed, are leaders in digital health and therapeutics for asthma and COPD, supporting patients in managing their condition with FDA cleared medical devices, consumer apps and access to clinical data for provider monitoring throughout the care journey.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">79%</span> of patients</span> reported being very satisfied by program',
      '<span className="text-blue font-bold"><span className="text-3xl block">57%</span> reduction</span> in hospitalizations over 12 months',
      '<span className="text-blue font-bold"><span className="text-3xl block">78%</span> reduction</span> in daily rescue inhaler usage',
    ]
  },
  {
    companyLogo: '/clickotine.png',
    companyLogoAltText: 'Clickotine Logo',
    companySummary: 'Clickotine provides personalized quit plans and monitoring with scientifically backed strategies to help overcome cravings, withdrawals, slips, and lapses. Combined with medication adherence programs and financial incentives, Clickotine offers improved member outcomes and cost savings.',
    statistics: [
      '<span className="text-blue font-bold"><span className="text-3xl block">45.2%</span> of participants</span> successfully stop smoking',
      '<span className="text-blue font-bold"><span className="text-3xl block">100.6</span> participants</span>',
      '<span className="text-blue font-bold"><span className="text-3xl block">214.6</span> average</span> completed interactions',
    ]
  },
];
